const MasterUserStructure = {
    userId: "",
    name: {
      firstName: "",
      lastName: ""
    },
    imageUrl: "",
    gender: "",
    ethenic: "",
    email: "",
    password: "",
    mobileNumber: "",
    devices: [],
    dateOfBirth: "",
    address: {
        street: "",
        city: "",
        state: "",
        zipCode: "",
        country: ""
    },
    isProfileSet: false,
    nProfiles: 0,
    isCommunitySet: false,
    isKlamitySet: false,
    occupation: "",
    isVerified: "",
    isBlueTickEnabled: false,
    isOotshavSet: "",
    isDeluzonSet: "",
    credibilityPoints: 0,
    isAdvertiser: "",
    isAdmin: ""
  };
  
  export default MasterUserStructure;
  